import Feature from "./../Feature.js";

export default function FromToEPSG(feature, from, to) {
    let clonedFeature = null;
    try {
        if (feature != null) {
            if (feature.getGeometry() != null) {
                clonedFeature = feature.getGeometry().clone();
            }
        }
        if (clonedFeature != null) {
            return new Feature(clonedFeature.transform(from, 'EPSG:' + to));
        }
        return null;
    }
    catch (e) {
        return null;
    }
}
